import { render } from "./menu-item.vue?vue&type=template&id=4ba8aa4e&scoped=true"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"

import "./menu-item.vue?vue&type=style&index=0&id=4ba8aa4e&scoped=true&lang=css"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba8aa4e"]])

export default __exports__